<div class="newpost-footer" [formGroup]="form">
  <div class="form-group">
    <label class="parent-label" *ngIf="field?.label">
      {{ field.label }}{{ field.validation?.required ? '*' : '' }}
    </label>
    <div class="uploadContainer">
      <label
        *ngIf="!(imageFeedPreview || form.get(field.name)?.value)"
        (click)="fileInput.click()"
        for="newpostUpload1"
        class="uploadFile custom-label-upload"
        [ngClass]="{
          'banner-type2': field.bannerImageType === feedPreviewType.TYPE_2
        }"
      >
        <input
          onclick="this.value = null"
          #fileInput
          (change)="fileChangeEvent($event)"
          type="file"
          class="upload"
          id="videoFeedPreview1"
          [accept]="application.IMAGE_ACCEPT_TYPES_INCLUDING_GIF"
          style="display: none"
          appMobileBridgeFileInput
          (mobileFileChange)="mobileFileChangeEvent($event)"
          [fileConfig]="{
            isMultiple: false,
            cropperOptions: field?.cropperOptions || cropperOptions
          }"
        />
        <em *ngIf="field.bannerImageType !== feedPreviewType.TYPE_2">+</em>
        <span *ngIf="field.bannerImageType !== feedPreviewType.TYPE_2">
          {{ 'Upload' }}
        </span>
        <div
          class="banner-image-type2"
          *ngIf="field.bannerImageType === feedPreviewType.TYPE_2"
        >
          <em class="icon-litebanner-upload"></em>
          <div class="image-title">
            {{ field.bannerImageType2Title || application.ADD_IMAGE }}
          </div>
          <div class="image-msg">
            {{ application.IMAGE_LIMIT_MSG }}
          </div>
          <app-button
            [btnField]="{
              type: 'button',
              label: field.bannerImageType2Label || 'SELECT FILE',
              class: 'btn btn-primary select-file-btn'
            }"
          ></app-button>
        </div>
      </label>
      <div
        *ngIf="imageFeedPreview || showProgress || form.get(field.name)?.value"
        class="uploadFileImageData"
        [ngClass]="field.bannerOrientationPortrait || null"
      >
        <div *ngIf="showProgress && cs.isBrowser" class="show-progress-bar pointer-none">
          <circle-progress
            [percent]="percent"
            [radius]="23"
            [outerStrokeWidth]="3"
            [innerStrokeWidth]="3"
            [outerStrokeColor]="cs.isWhiteLabelWeb ? cs.whiteLabelData?.data?.whiteLabel?.theme_color : '#09c6da'"
            [innerStrokeColor]="'#47665f'"
            [animation]="false"
            [animationDuration]="300"
            [showSubtitle]="false"
            [backgroundPadding]="0"
            [titleFontSize]="10"
            [titleColor]="'#ffffff'"
            [unitsColor]="'#ffffff'"
            [space]="-3"
          ></circle-progress>
        </div>
        <img
          appDisableRightClick
          appMobileOptimization
          [originalUrl]="imageFeedPreview || form.get(field.name)?.value"
          [src]="imageFeedPreview || form.get(field.name)?.value"
          [format]="'webp'"
          alt="Banner Preview"
          loading="lazy"
          decoding="async"
        />
        <a (click)="removeVideoFeedImage()" class="close" style="z-index: 10">
          &times;
        </a>
      </div>
    </div>
  </div>
  <app-image-cropper
    *ngIf="isOpen"
    [imageChangeEvent]="imageChangedEvent"
    [isOpen]="isOpen"
    [cropperOptions]="field?.cropperOptions || cropperOptions"
    [imageWidth]="imageWidth"
    (closeCrop)="cancelCrop($event)"
    (cropImageUpload)="imageFeedClicked($event)"
  ></app-image-cropper>
  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
